import { Badge } from "@/clientWeb/components/ui/badge";
import { MessageCircleMore } from "lucide-react";
import { ControlButton } from "../common/ControlButton";
import { useTranslation } from "@/clientWeb/i18n/LanguageContext";

interface ChatControlProps {
  chatOn: boolean;
  unreadChatCount?: number;
  onToggleChat: () => void;
}

export function ChatControl({ chatOn, unreadChatCount = 0, onToggleChat }: ChatControlProps) {
  const t = useTranslation();
  return (
    <div className="relative">
      <ControlButton active={chatOn} onClick={onToggleChat} label={t("controlBar.chatWithEveryone")}>
        <MessageCircleMore className="h-5 w-5 text-white" />
      </ControlButton>
      {/* Only badge shown here. A second, unconditional `2` used to sit on this
          exact spot ("dummy badge for testing") and covered the real one, so the
          chat button read 2 forever — including with zero unread. */}
      {unreadChatCount > 0 && (
        <Badge className="absolute -top-1 -right-1 h-5 min-w-[20px] items-center justify-center bg-red-500 text-white text-xs hover:bg-red-600">
          {unreadChatCount > 99 ? "99+" : unreadChatCount}
        </Badge>
      )}
    </div>
  );
}
